import { ref, computed, onMounted } from 'vue';

// store
import { useGl } from '@store/ts/gl';
import { useBots } from '@store/bots';
import { useRefs } from '@store/ts/refs';

export default function (props, context) {
    // store
    const gl = useGl();
    const bots = useBots();
    const refs = useRefs();

    // vars
    const dataForm = bots.dataForm;
    const show = ref(false);
    const newTagName = ref('');
    const botRefsTagsOptions = ref([]);

    const localValue = computed(() => {
        return dataForm.tags.map(({ id }) => String(id));
    });

    const updateValue = v => {
        dataForm.tags = [];
        
        v.forEach(el => {
            const item = botRefsTagsOptions.value.find(({ value }) => value == el);

            if (item)
                dataForm.tags.push({
                    title: item.label,
                    id: item.value,
                });
        });
    };

    const addNewTag = () => {
        const idx = botRefsTagsOptions.value.findIndex(({ label }) => newTagName.value === label);

        if (!~idx) {
            const id = `__new_tag_${Math.floor((Math.random() * 10000000))}`;
            botRefsTagsOptions.value.push({value: id, label: newTagName.value });
            dataForm.tags.push({
                title: newTagName.value,
                id,
            });
            newTagName.value = '';
        } else {
            dataForm.tags.push({
                title: newTagName.value,
                id: botRefsTagsOptions.value[idx].value,
            });
            newTagName.value = '';
        }
    };

    const prepareOptions = () => {
        const arr = Object.values(bots.tags).map(el => ({
            label: el.title,
            value: String(el.id),
            ...el,
        }));

        botRefsTagsOptions.value = arr;
    };

    onMounted(() => {
        prepareOptions();
    });

    return {
        gl,
        show,
        bots,
        dataForm,
        localValue,
        botRefsTagsOptions,
        updateValue,
        newTagName,
        addNewTag,
        refs,
    };
}